import { render, staticRenderFns } from "./AddPropertyUnit.vue?vue&type=template&id=780ea6d6&scoped=true"
import script from "./AddPropertyUnit.vue?vue&type=script&lang=js"
export * from "./AddPropertyUnit.vue?vue&type=script&lang=js"
import style0 from "./AddPropertyUnit.vue?vue&type=style&index=0&id=780ea6d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "780ea6d6",
  null
  
)

export default component.exports